/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@compiled/react';
import { fg } from '@atlaskit/platform-feature-flags';

import Item, { type SwitcherItemProps } from './item';

// add !important to override the default styles
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const styles = cssMap({
	item: {
		paddingTop: `${token('space.100')} !important`,
		paddingRight: `${token('space.100')} !important`,
		paddingBottom: `${token('space.100')} !important`,
		paddingLeft: `${token('space.100')} !important`,
		borderRadius: `${token('radius.small')} !important`,
		textDecoration: 'none !important',
		'&:hover, &:focus, &:active, &:focus-visible': {
			color: 'inherit',
		},
	},
	// Reduced padding for items with description when lozenge resize is enabled.
	itemWithDescription: {
		paddingTop: `${token('space.075')} !important`,
		paddingBottom: `${token('space.075')} !important`,
	},
	icon: {
		marginRight: `${token('space.negative.050')}`,
	},
});

const _default_1: React.ForwardRefExoticComponent<
	Omit<SwitcherItemProps, 'ref'> & React.RefAttributes<HTMLAnchorElement>
> = React.forwardRef<HTMLAnchorElement, SwitcherItemProps>((props, focusRef) => {
	const { icon, isDraggable, setIsLinkItemHovered, isOverflowButton, ...rest } = props;
	const isLozengeResizeEnabled = fg('navx-4967-lozenge-resize');
	return (
		<Item
			icon={<span css={styles.icon}>{icon}</span>}
			{...rest}
			css={[styles.item, isLozengeResizeEnabled && rest.description && styles.itemWithDescription]}
			isDraggable={isDraggable}
			setIsLinkItemHovered={setIsLinkItemHovered}
			ref={focusRef}
			isOverflowButton={isOverflowButton}
		/>
	);
});
export default _default_1;
